import React from 'react';
import styled from "styled-components";
import PersonalDetails from './PersonalDetails';
import { useMediaQuery } from 'react-responsive';
import { DashboardIcon } from 'Components/PageComponents';

const Container = styled.div`
    width: 75%;
    @media (max-width: 1050px) {
        width: 90%;
    }
`;

function MyDetails() {

    const desktopView = useMediaQuery({
        query: '(min-width: 1050px)'
    })
    
    return (
        <Container>
            {desktopView && <DashboardIcon src="/images/homepage/calendar.png"/>}
            <PersonalDetails />
        </Container>
    );
}
export default MyDetails;